import {
  GET_VENDOR_CATS_SUCCESS,
  GET_VENDOR_CATS_FAIL,
  GET_VENDOR_CAT_PROFILE_SUCCESS,
  GET_VENDOR_CAT_PROFILE_FAIL,
  ADD_VENDOR_CAT_SUCCESS,
  ADD_VENDOR_CAT_FAIL,
  UPDATE_VENDOR_CAT_SUCCESS,
  UPDATE_VENDOR_CAT_FAIL,
  DELETE_VENDOR_CAT_SUCCESS,
  DELETE_VENDOR_CAT_FAIL,
  DELETE_VENDOR_CAT,
  ADD_NEW_VENDOR_CAT,
  UPDATE_VENDOR_CAT
  
} from "./actionTypes";

const INIT_STATE = {
  vendor_cats: [],
  vendor_catProfile: {},
  total_page: 0,
  error: {},
  loading:false
};

const vendor_cats = (state = INIT_STATE, action) => {
  // console.log(action)
  switch (action.type) {
    case GET_VENDOR_CATS_SUCCESS:
      return {
        ...state,
        vendor_cats: action.payload.data,
        total_page:action.payload.total_page
      }

    case GET_VENDOR_CATS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
      case ADD_NEW_VENDOR_CAT:
        return {
          ...state,
          loading:true
        }
    case ADD_VENDOR_CAT_SUCCESS:
      return {
        ...state,
        vendor_cats: [...state.vendor_cats, action.payload],
        loading:false
      }

    case ADD_VENDOR_CAT_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
      case UPDATE_VENDOR_CAT:
        return {
          ...state,
          loading:true
        }
    case UPDATE_VENDOR_CAT_SUCCESS:
      return {
        ...state,
        vendor_cats: state.vendor_cats.map(vendor_cat =>
          vendor_cat.id.toString() === action.payload.id.toString()
            ? { ...vendor_cat, ...action.payload }
            : vendor_cat
        ),
        loading:false
      }

    case UPDATE_VENDOR_CAT_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
    case DELETE_VENDOR_CAT:
      return {
        ...state,
        loading:true
      }
    case DELETE_VENDOR_CAT_SUCCESS:
      return {
        ...state,
        vendor_cats: state.vendor_cats.filter(
          vendor_cat => vendor_cat.id.toString() !== action.payload.id.toString()
        ),
        loading:false
      }

    case DELETE_VENDOR_CAT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_VENDOR_CAT_PROFILE_SUCCESS:
      return {
        ...state,
        vendor_catProfile: action.payload,
      }

    case GET_VENDOR_CAT_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
};

export default vendor_cats;
